import script from "./SpecialRuleList.vue?vue&type=script&lang=ts&setup=true&name=StockList"
export * from "./SpecialRuleList.vue?vue&type=script&lang=ts&setup=true&name=StockList"

import "./SpecialRuleList.vue?vue&type=style&index=0&id=4fb95dc4&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/v-admin/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb95dc4"]])

export default __exports__